import { call, put, takeLatest } from "redux-saga/effects";
import {
  bookingViewEffect,
  bookingViewAllEffect,
  fetchAllBookingsEffect,
  bookingAddEffect,
  bookingDeleteEffect,
  fetchServiceTypeEffect,
  fetchCustomerBookingsEffect,
  fetchTransitServiceTypeEffect,
  updateBookingDiscountStatusAPI,
  instantBookingAddEffect,
  instantBookingTokenEffect,
  bookingEditEffect,
  fetchAllBookingEffect,
  resendRazorpayLinkAPI,
  updatePaymentStatusEffect,
  updateBookingStatusEffect,
} from "./BookingEffect";

import {
  fetchBookingsSuccess,
  fetchBookingsFailure,
  fetchBookingSuccess,
  fetchBookingFailure,
  addBookingSuccess,
  addBookingFailure,
  deleteBookingSuccess,
  deleteBookingFailure,
  fetchServiceTypeSuccess,
  fetchServiceTypeFailure,
  fetchAllBookingsSuccess,
  fetchAllBookingsFailure,
  fetchCustomerBookingsSuccess,
  fetchCustomerBookingsFailure,
  fetchTransitServiceTypeSuccess,
  fetchTransitServiceTypeFailure,
  fetchComplementaryBookingsSuccess,
  fetchComplementaryBookingsFailure,
  updateBookingDiscountApprovalStatusFailure,
  updateBookingDiscountApprovalStatusSuccess,
  insertInstantBookingSuccess,
  insertInstantBookingFailure,
  instantBookingTokenGeneratorSuccess,
  instantBookingTokenGeneratorFailure,
  fetchInstantBookingsFailure,
  fetchInstantBookingsSuccess,
  editBookingSuccess,
  editBookingFailure,
  getAllBookingsSuccess,
  getAllBookingsFailure,
  fetchAllBookingSuccess,
  fetchAllBookingFailure,
  resendRazorpayLinkSuccess,
  resendRazorpayLinkFailure,
  updatePaymentStatusSuccess,
  updatePaymentStatusFailure,
  updateBookingStatusSuccess,
  updateBookingStatusFailure,
} from "./BookingAction";

import {
  FETCH_BOOKINGS_REQUEST,
  FETCH_BOOKING_REQUEST,
  ADD_BOOKING_REQUEST,
  DELETE_BOOKING_REQUEST,
  FETCH_SERVICE_TYPE_REQUEST,
  FETCH_ALL_BOOKINGS_REQUEST,
  FETCH_CUSTOMER_BOOKINGS_REQUEST,
  FETCH_TRANSIT_SERVICE_TYPE_REQUEST,
  FETCH_COMPLEMENTARY_BOOKINGS_REQUEST,
  UPDATE_BOOKING_DISCOUNT_APPROVAL_STATUS_REQUEST,
  INSERT_INSTANT_BOOKING_REQUEST,
  INSTANT_TOKEN_GENERATOR_REQUEST,
  FETCH_INSTANT_BOOKINGS_REQUEST,
  EDIT_BOOKING_REQUEST,
  GET_ALL_BOOKINGS_REQUEST,
  FETCH_ALL_BOOKING_REQUEST,
  RAZORPAY_RESEND_LINK_REQUEST,
  UPDATE_PAYMENT_STATUS_REQUEST,
  UPDATE_BOOKING_STATUS_REQUEST,
} from "./BookingType";

import axiosInstance from "../instance/AxiosInstance";

function* bookingViewSaga({ payload }) {
  try {
    const response = yield call(bookingViewEffect, payload);
    yield put(fetchBookingSuccess(response));
  } catch (error) {
   
    yield put(fetchBookingFailure(error || "Failed to Fetch Booking"));
  }
}

function* bookingViewAllSaga({ payload }) {
  try {
    const response = yield call(bookingViewAllEffect, payload);
    yield put(fetchBookingsSuccess(response));
  } catch (error) {

    yield put(fetchBookingsFailure(error || "Failed to Fetch Bookings"));
  }
}

function* fetchAllBookingsSaga(action) {
  const { booked_type } = action.payload;
  try {
    const response = yield call(fetchAllBookingsEffect, booked_type);
    yield put(getAllBookingsSuccess(response));
  } catch (error) {
   
    yield put(getAllBookingsFailure(error || "Failed to Fetch All Bookings"));
  }
}

function* fetchBookingsSaga(action) {
  
  try {
    const response = yield call(fetchAllBookingEffect, action.payload);
    yield put(fetchAllBookingSuccess(response));
  } catch (error) {

    yield put(fetchAllBookingFailure(error || "Failed to Fetch All Bookings"));
  }
}

function* fetchCustomerBookingsSaga(action) {
  const {
    customer_id,
    pageNo,
    pageSize,
    type,
    currentDate,
    vendor_id,
    booked_type,
    search,
    search_by,
    from_date,  // ADD DATE PARAMETERS
    to_date,    // ADD DATE PARAMETERS
  } = action.payload;
  
  try {
    const response = yield call(
      fetchCustomerBookingsEffect,
      customer_id,
      pageNo,
      pageSize,
      type,
      currentDate,
      vendor_id,
      booked_type,
      search,
      search_by,
      from_date,  // PASS DATE PARAMETERS
      to_date     // PASS DATE PARAMETERS
    );
    yield put(fetchCustomerBookingsSuccess(response));
  } catch (error) {
    yield put(fetchCustomerBookingsFailure(error));
  }
}



function* InstantBookingAddSaga({ payload }) {
  try {
    const response = yield call(instantBookingAddEffect, payload);
    yield put(insertInstantBookingSuccess(response));
  } catch (error) {
    yield put(insertInstantBookingFailure(error || "Failed to Add Booking"));
  }
}

function* bookingEditSaga({ payload }) {
  try {
    const response = yield call(bookingEditEffect, payload);
    
    yield put(editBookingSuccess(response));
  } catch (error) {
    yield put(editBookingFailure(error || "Failed to Add Booking"));
  }
}

function* InstantBookingTokenSaga() {
  try {
    const response = yield call(instantBookingTokenEffect);
    yield put(instantBookingTokenGeneratorSuccess(response.token));
  } catch (error) {
    yield put(
      instantBookingTokenGeneratorFailure(error || "Failed to Add Booking")
    );
  }
}

function* bookingDeleteSaga(payload) {
 
  try {
    const response = yield call(bookingDeleteEffect, payload);

    yield put(deleteBookingSuccess(response.message));
  } catch (error) {
    yield put(deleteBookingFailure(error || "Failed to Delete Booking"));
  }
}

function* serviceGetTypeSaga({ payload }) {
  try {
    const response = yield call(fetchServiceTypeEffect, payload);

    yield put(fetchServiceTypeSuccess(response?.data?.data));
  } catch (error) {
    yield put(fetchServiceTypeFailure(error));
  }
}

function* transitServiceGetTypeSaga({ payload }) {
  
  try {
    const response = yield call(fetchTransitServiceTypeEffect, payload);

    yield put(fetchTransitServiceTypeSuccess(response?.data?.data));
  } catch (error) {
    yield put(fetchTransitServiceTypeFailure(error));
  }
}

function* fetchComplementaryBookingsSaga(action) {
  const { 
    pageNo, 
    pagesize, 
    approove_status, 
    currentDate, 
    search, 
    search_by,
    from_date,  // ADD DATE PARAMETERS
    to_date     // ADD DATE PARAMETERS
  } = action.payload;
  
  const params = { 
    approove_status, 
    booked_type: 2, 
    currentDate 
  };

  // Add date filters if provided
  if (from_date) {
    params.from_date = from_date;
  }
  if (to_date) {
    params.to_date = to_date;
  }

  if (action.payload.search) {
    params.pagination_required = false;
    params.search = search;

    if (search_by && search_by.trim() !== "") {
      params.search_by = search_by;
    }
  } else {
    params.pagination_required = true;
    params.pagesize = pagesize;
    params.pageNo = pageNo;
  }

  try {
    const response = yield call(
      axiosInstance.get,
      `/bookservice/complementrybookingservice`,
      {
        params,
      }
    );
    yield put(fetchComplementaryBookingsSuccess(response.data));
  } catch (error) {
    yield put(fetchComplementaryBookingsFailure(error.message));
  }
}

function* fetchInstantBookingsSaga(action) {
  const { 
    pageNo, 
    pagesize, 
    type, 
    currentDate,
    search,
    search_by,
    from_date,  // ADD DATE PARAMETERS
    to_date     // ADD DATE PARAMETERS
  } = action.payload;
  
  const params = { 
    type, 
    booked_type: 3, 
    currentDate 
  };

  // Add date filters if provided
  if (from_date) {
    params.from_date = from_date;
  }
  if (to_date) {
    params.to_date = to_date;
  }

  if (action.payload.search) {
    params.pagination_required = false;
    params.search = search;

    if (search_by && search_by.trim() !== "") {
      params.search_by = search_by;
    }
  } else {
    params.pagination_required = true;
    params.pagesize = pagesize;
    params.pageNo = pageNo;
  }
  
  try {
    const response = yield call(axiosInstance.get, `/bookservice/list`, {
      params,
    });
    yield put(fetchInstantBookingsSuccess(response.data));
  } catch (error) {
    yield put(fetchInstantBookingsFailure(error.message));
  }
}

function* handleUpdateBookingDiscountApprovalStatus(action) {
  try {
    const response = yield call(updateBookingDiscountStatusAPI, action.payload);

    yield put(updateBookingDiscountApprovalStatusSuccess(response));
  } catch (error) {
    yield put(
      updateBookingDiscountApprovalStatusFailure(
        error.response?.data?.message || "Failed to update status"
      )
    );
  }
}
function* bookingAddSaga({ payload }) {
  try {
    const response = yield call(bookingAddEffect, payload);
    yield put(addBookingSuccess(response));
  } catch (error) {
    yield put(addBookingFailure(error || "Failed to Add Booking"));
  }
}

function* resendRazorpayLinkSaga(action) {
  try {
    const response = yield call(resendRazorpayLinkAPI, action.payload);
    yield put(resendRazorpayLinkSuccess(response));
  } catch (error) {
    yield put(resendRazorpayLinkFailure(error || "Failed to resend link"));
  }
}

function* updatePaymentStatusSaga(action) {
  try {
    const response = yield call(updatePaymentStatusEffect, action.payload);
    yield put(updatePaymentStatusSuccess(response));
  } catch (error) {
    yield put(updatePaymentStatusFailure(error || "Failed to update payment status"));
  }
}

function* updateBookingStatusSaga(action) {
  try {
    const response = yield call(updateBookingStatusEffect, action.payload);
    yield put(updateBookingStatusSuccess(response));
  } catch (error) {
    yield put(updateBookingStatusFailure(error || "Failed to update Booking status"));
  }
}
export default function* bookingSaga() {
   yield takeLatest(UPDATE_PAYMENT_STATUS_REQUEST, updatePaymentStatusSaga);
    yield takeLatest(UPDATE_BOOKING_STATUS_REQUEST, updateBookingStatusSaga);
  yield takeLatest(FETCH_BOOKINGS_REQUEST, bookingViewAllSaga);
  yield takeLatest(GET_ALL_BOOKINGS_REQUEST, fetchAllBookingsSaga);
  yield takeLatest(FETCH_ALL_BOOKING_REQUEST, fetchBookingsSaga);
  yield takeLatest(FETCH_BOOKING_REQUEST, bookingViewSaga);
  yield takeLatest(ADD_BOOKING_REQUEST, bookingAddSaga);
  yield takeLatest(DELETE_BOOKING_REQUEST, bookingDeleteSaga);
  yield takeLatest(FETCH_SERVICE_TYPE_REQUEST, serviceGetTypeSaga);
  yield takeLatest(FETCH_CUSTOMER_BOOKINGS_REQUEST, fetchCustomerBookingsSaga);
  yield takeLatest(INSERT_INSTANT_BOOKING_REQUEST, InstantBookingAddSaga);
  yield takeLatest(INSTANT_TOKEN_GENERATOR_REQUEST, InstantBookingTokenSaga);
  yield takeLatest(EDIT_BOOKING_REQUEST, bookingEditSaga);
  yield takeLatest(
    FETCH_TRANSIT_SERVICE_TYPE_REQUEST,
    transitServiceGetTypeSaga
  );
  yield takeLatest(
    FETCH_COMPLEMENTARY_BOOKINGS_REQUEST,
    fetchComplementaryBookingsSaga
  );
  yield takeLatest(
    UPDATE_BOOKING_DISCOUNT_APPROVAL_STATUS_REQUEST,
    handleUpdateBookingDiscountApprovalStatus
  );
  yield takeLatest(FETCH_INSTANT_BOOKINGS_REQUEST, fetchInstantBookingsSaga);
   yield takeLatest(RAZORPAY_RESEND_LINK_REQUEST, resendRazorpayLinkSaga);
}
